export default ($wire, { id, field, value }) => ({
    editable: false,
    id,
    dataField: field,
    value,

    init(){
        this.$watch('value', () => this.save());
    },

    async save(){
        await $wire.inputTextChanged({
            id: this.id,
            field: this.dataField,
            value: this.value,
        });

        if (this.$refs.error) {
            return;
        }

        this.close();
    },

    open(){
        this.editable = true;
        setTimeout(() => this.$refs.editable.focus(), 100);
    },

    close(){
        this.editable = false;
    },
});
